var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch",on:{"click":_vm.toggle}},[_c('span',{ref:"yes",staticClass:"badge badge-pill"},[_vm._v(" "+_vm._s(_vm.labelYes)+" ")]),_c('span',{ref:"no",staticClass:"badge badge-pill"},[_vm._v(" "+_vm._s(_vm.labelNo)+" ")]),(_vm.yesWidth)?_c('span',{staticClass:"badge badge-pill badge-floating",class:{
			yes: _vm.isOn,
			no: !_vm.isOn,
		},style:({
			left: !_vm.isOn ? (_vm.yesWidth + 2) + 'px' : '2px',
			width: _vm.isOn ? _vm.yesWidth + 'px' : _vm.noWidth + 'px',
		})},[(!_vm.loading)?[(_vm.isOn)?[_vm._v(_vm._s(_vm.labelYes))]:_vm._e(),(!_vm.isOn)?[_vm._v(_vm._s(_vm.labelNo))]:_vm._e()]:[_c('Loader',{staticClass:"micro"})]],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }